import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { AIFbaseUrl } from "../../../Constant/Matcher";

export const RegisterApi = createApi({
  reducerPath: "RegisterApi",
  baseQuery: fetchBaseQuery({
    baseUrl: AIFbaseUrl,
    mode: "cors",
  }),
  endpoints: (builder) => ({
   
    loginSubmit: builder.mutation({
      query: (data) => ({
        url: `login`,
        method: "POST",
        body: data,
      }),
    }), 
    
  }),
});

export const {useLoginSubmitMutation} = RegisterApi;
